export const DISTRICT_LIST_SET = 'DISTRICT_LIST_SET';
export const CANCER_SITE_SET = 'CANCER_SITE_SET';
export const ICD10_LIST_SET = 'ICD10_LIST_SET';
export const TRENDS_YEARS_LIST_SET = 'TRENDS_YEARS_LIST_SET';